import { render, staticRenderFns } from "./DatosDelegado.vue?vue&type=template&id=472c4cf5"
import script from "./DatosDelegado.vue?vue&type=script&lang=js"
export * from "./DatosDelegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472c4cf5')) {
      api.createRecord('472c4cf5', component.options)
    } else {
      api.reload('472c4cf5', component.options)
    }
    module.hot.accept("./DatosDelegado.vue?vue&type=template&id=472c4cf5", function () {
      api.rerender('472c4cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/infoBase/DatosDelegado.vue"
export default component.exports